<template>
    <v-container>
      <v-row>
        <v-col md="12" class="pa-6 text-left text-justify">
          <div class="my-6">
                    <p class="text-h4 text--primary">
                        <TextHeading :level=3>Audyt Projektu</TextHeading>
                    </p>
                    <div class="text-body-1 text--primary">
                      Świadomi ryzyka Beneficjenci chcąc uniknąć w realizowanych przez siebie projektach wydatków niekwalifikowalnych decydują się na audyty zewnętrzne.
                    </div>
                    <br />
                    <div class="text-body-1 text--primary">
                      Głównym celem audytu, w przeciwieństwie do kontroli zapobieganie uchybieniom i nieprawidłowościom oraz uzyskanie dowodów pozwalających na jednoznaczną ocenę, czy realizacja projektu przebiega zgodnie z umową o dofinansowanie, wnioskiem o dofinansowanie oraz z przepisami prawa.
                    </div>
                    <br />
                    <div class="text-body-1 text--primary">
                      Audyt obejmuje przede wszystkim analizę dokumentacji oraz stosowanych procedur kontroli wewnętrznej w odniesieniu do przekazywania i rozliczania otrzymanych środków, procedur akceptacji wydatków kwalifikowanych w zakresie ich zasadności i odpowiedniego udokumentowania, a także sprawozdawczości z realizacji postanowień umowy o dofinansowanie.
                    </div>
                    <br />
                    <div class="text-body-1 text--primary">
                      <b>Audyty projektów unijnych</b> prowadzone są przez niezależne zespoły składające się z audytorów wewnętrznych i biegłych rewidentów o wysokich kwalifikacjach i doświadczeniu w kontroli projektów unijnych, które dokonują audytów pod kątem prawidłowego przebiegu realizacji projektów. W szczególności sprawdzeniu podlegają:
                    </div>
                    <v-list dense disabled>
                      <v-list-item
                        v-for="(item, i) in range"
                        :key="i"
                      >
                        <v-list-item-icon>
                          <v-icon>{{ item.icon }}</v-icon>
                        </v-list-item-icon>

                        <v-list-item-title class="text-body-1 text--primary text-wrap font-weight-regular">{{ item.text }}</v-list-item-title>
                      </v-list-item>
                    </v-list>
                    <div class="text-body-1 text--primary">
                      Nasi audytorzy posiadają wieloletnie doświadczenie w przeprowadzaniu audytów zewnętrznych programów finansowanych ze środków Unii Europejskiej oraz programów finansowanych z Budżetu Państwa.
                      Audyt przeprowadzamy zgodnie z powszechnie uznawanymi standardami audytu oraz zgodnie z wytycznymi Instytucji Zarządzających oraz wytycznymi Komisji Europejskiej wydanymi dla konkretnych Programów. 
                      Na podstawie przeprowadzonego audytu sporządzamy raport i opinię o prawidłowości realizacji projektu i jego finansowaniu.
                    </div>
          </div>
        </v-col>
      </v-row>
    </v-container>
  </template>
  <script>
  import TextHeading from "@/modules/TextHeading";
  export default {
  
    components: {TextHeading},

    data: () => ({
      range: [
        {
          text: 'dokumentacja dotycząca projektu,',
          icon: "mdi-circle-medium"
        },
        {
          text: 'podjęcie działań przewidzianych we wniosku o dofinansowanie,',
          icon: "mdi-circle-medium"
        },
        {
          text: 'rzeczywiste poniesienie deklarowanych wydatków,',
          icon: "mdi-circle-medium"
        },
        {
          text: 'kwalifikowalność poniesionych wydatków, sposób ich dokumentowania i ujęcia na wyodrębnionym rachunku bankowym, zgodność kwot wynikających z wniosku o płatność z zapisami księgowymi,',
          icon: "mdi-circle-medium"
        },
        {
          text: 'sposób monitorowania projektu, raportowania o postępach wdrażania projektu oraz dotrzymanie harmonogramu realizacji zadań,',
          icon: "mdi-circle-medium"
        },
        {
          text: 'stosowanie zasad dotyczących promocji i reklamy projektu,',
          icon: "mdi-circle-medium"
        },
        {
          text: 'wiarygodność sprawozdań z realizacji projektów przekazywanych przez beneficjenta, poprzez weryfikację i potwierdzenie wykonania prac, istnienia zakupionych towarów oraz wykonania usług zamówionych w ramach projektu,',
          icon: "mdi-circle-medium"
        },
        {
          text: 'poprawność stosowania ustawy Prawo Zamówień Publicznych,',
          icon: "mdi-circle-medium"
        },
        {
          text: 'sposób archiwizowania dokumentów.',
          icon: "mdi-circle-medium"
        },
      ],
    })
  }
  </script>